(function () {
	const initSliders = () => {
		$(".tabs-section").each(function () {
			if ($(this).hasClass("slider_started")) {
				return;
			}
			$(this).addClass("slider_started");
			const id = $(this).attr("id");
			const box = $(this).find(".tabs");
			const autoplay = box.data("autoplay");
			const delay = box.data("delay") * 1000;

			let swiperParms = {
				effect: box.data("effect"),
				speed: box.data("speed") * 1000,
				slidesPerView: 1,
				autoHeight: false,
				keyboard: true,
				loop: true,
				watchSlidesProgress: true,
				allowTouchMove: true,
			};

			if (autoplay) {
				swiperParms.autoplay = {
					delay: delay,
					disableOnInteraction: false,
				};
			}

			const mainSwiper = new Swiper(`#${id} .tabs_box`, swiperParms);
			let secondSwiperElement = $(this).find(".tabs_box-content");
			if (secondSwiperElement.length > 0) {
				const secondSwiper = new Swiper(
					`#${id} .tabs_box-content`,
					swiperParms
				);
				mainSwiper.on("slideChange", function () {
					secondSwiper.slideTo(mainSwiper.realIndex);
				});
				secondSwiper.on("slideChange", function () {
					mainSwiper.slideTo(secondSwiper.realIndex);
				});
			}

			const isType3 = $(this).find(".tabs_wrapper-type3").length > 0;

			const sliderThumbs = new Swiper(`#${id} .tabs-thumb_wrapper`, {
				spaceBetween: 0,
				slidesPerView: 1,
				speed: box.data("speed") * 1000,
				freeMode: false,
				allowTouchMove: true,
				watchSlidesVisibility: true,
				watchSlidesProgress: true,
				watchOverflow: true,
				loop: true,
				breakpoints: {
					990: {
						spaceBetween: 16,
						slidesPerView: box.data("per-row"),
						allowTouchMove: false,
						loop: false,
					},
				},
			});

			function updateActiveSlide(mainSwiper, sliderThumbs) {
				const activeIndex = mainSwiper.realIndex;
				sliderThumbs.slides.forEach(function (slide) {
					slide.classList.remove("active");
				});
				if (sliderThumbs.slides[activeIndex]) {
					sliderThumbs.slides[activeIndex].classList.add("active");
				}
			}

			function updateThumbs(activeIndex) {
				sliderThumbs.slideToLoop(activeIndex);
				sliderThumbs.slides.forEach((slide, index) => {
					slide.classList.toggle("active", index === activeIndex);
				});
			}

			mainSwiper.on("slideChange", function () {
				updateActiveSlide(mainSwiper, sliderThumbs);
				const activeIndex = mainSwiper.realIndex;
				updateThumbs(activeIndex);
			});

			sliderThumbs.on("click", function (e) {
				const clickedIndex = sliderThumbs.clickedIndex;
				if (clickedIndex != null) {
					mainSwiper.slideToLoop(clickedIndex);
					sliderThumbs.slideToLoop(clickedIndex);
				}
			});

			if (sliderThumbs.slides[0]) {
				sliderThumbs.slides[0].classList.add("active");
			}
		});
	};

	document.addEventListener("DOMContentLoaded", function () {
		initSliders();
		document.addEventListener("shopify:section:load", function () {
			initSliders();
		});
	});
})();
